import { useEffect, useRef, useState } from 'react';
import ReactModal from 'react-modal';
import Avatar, { genConfig } from 'funifier-nice-avatar';
import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';
import Button from 'components/ui/button';
import { useModal } from 'context/ModalContext';
import { uploadPicture, updateUserProfile } from 'services/profile.service';
import { useAuth } from 'context/AuthContext';
import { toast } from 'react-toastify';
// import { BiTrash } from 'react-icons/bi';
// import { FaRegTrashAlt } from 'react-icons/fa';
import { GrTrash } from 'react-icons/gr';
import { FaCheckCircle, FaEye, FaEyeSlash, FaTimesCircle } from 'react-icons/fa';
import { AvatarConfig, GetAvatarDefaultOptions } from './config';

import noImage from 'assets/img/no-image.png';
import { RiImageEditFill } from 'react-icons/ri';
import { updateUserPass } from 'services/auth.service';

const config = genConfig();

const avatarDefaultOptions = GetAvatarDefaultOptions() as any;

let imagePreviewTimeout: any = null;

export function AvatarModal(props: any) {
  // const modalID = "achievement";

  const { user, refreshUser } = useAuth();

  const modalID = 'avatar';

  const senhaAtualRef = useRef<any>();
  const novaSenhaRef = useRef<any>();
  const confirmarNovaSenhaRef = useRef<any>();

  const [senhaAtual, setSenhaAtual] = useState<any>();
  const [novaSenha, setNovaSenha] = useState<any>();
  const [confirmarNovaSenha, setConfirmarNovaSenha] = useState<any>();
  const [typeInput1, setTypeInput1] = useState<'password' | 'text'>('password');
  const [typeInput2, setTypeInput2] = useState<'password' | 'text'>('password');
  const [typeInput3, setTypeInput3] = useState<'password' | 'text'>('password');
  const [passError, setPassError] = useState<string>();

  const [loading, setLoading] = useState(false);

  const [modalIsOpen, setIsOpen] = useState(false);
  const [avatarConfig, setAvatarConfig] = useState<AvatarConfig>(config);

  const { openModal, modalData, closeModal } = useModal();

  const [avatarType, setAvatarType] = useState(0);

  const [image, setImage] = useState('');
  const editor = useRef<any>(null);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    setImage('');
    setLoading(false);
    setAvatarType(0);
    setTypeInput1('password');
    setTypeInput2('password');
    setTypeInput3('password');
    setSenhaAtual(undefined);
    setNovaSenha(undefined);
    setConfirmarNovaSenha(undefined);
    setPassError(undefined);
    closeModal();
  }

  function afterOpenModal() {}

  async function handleNewPass() {
    if (typeof senhaAtual !== 'string' || !senhaAtual.trim().length) {
      return setPassError('Por favor, preencha o campo senha corretamente.');
    } else if (typeof novaSenha !== 'string' || !novaSenha.trim().length) {
      return setPassError('Por favor, preencha o campo nova senha corretamente.');
    } else if (typeof confirmarNovaSenha !== 'string' || !confirmarNovaSenha.trim().length) {
      return setPassError('Por favor, preencha o campo confirmar nova senha corretamente.');
    } else if (novaSenha.trim() !== confirmarNovaSenha.trim()) {
      return setPassError('A nova senha precisa ser idêntica à confirmação da nova senha.');
    } else if (!!senhaAtual.match(/ /gi) || !!novaSenha.match(/ /gi) || !!confirmarNovaSenha.match(/ /gi)) {
      return setPassError('As senhas não podem conter espaços.');
    } else if (novaSenha.trim() === senhaAtual.trim()) {
      return setPassError('A nova senha precisa ser diferente da senha antiga.');
    }

    setPassError(undefined);
    setLoading(true);

    try {
      const resp = await updateUserPass(senhaAtual.trim(), novaSenha.trim());
      if (resp?.data?.code === 200) {
        handleCloseModal();
        toast(`👍 Sua senha foi atualizada com sucesso!`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        setPassError('Não foi possível alterar a senha. Por favor, verifique os dados e tente novamente.');
      }
    } catch (error) {
      setPassError('Não foi possível alterar a senha. Por favor, verifique os dados e tente novamente.');
    }

    setLoading(false);
  }

  async function handleUpload() {
    if (avatarType === 2) {
      return handleNewPass();
    }

    let profileImage: any = {};

    setLoading(true);

    if (image) {
      const dataUrl = editor.current.getImageScaledToCanvas().toDataURL();

      if (dataUrl) {
        const uploadResult = await uploadPicture(dataUrl);

        if (uploadResult) {
          const url = uploadResult.url;
          profileImage = {
            image: {
              small: { url },
              medium: { url },
              original: { url },
            },
          };
        }
      }
    }

    profileImage['extra'] = {
      ...user?.extra,
      avatar_type: avatarType,
      avatar: avatarConfig,
    };

    if (profileImage) {
      // console.log(profileImage);
      if (!user) return;
      await updateUserProfile({ _id: user._id, ...profileImage });
      refreshUser();
      handleCloseModal();
      toast(`👍 Seu perfil foi atualizado com sucesso!`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  function handleImageChange() {
    if (imagePreviewTimeout) {
      clearTimeout(imagePreviewTimeout);
    }

    imagePreviewTimeout = setTimeout(() => {
      getImageUrl();
    }, 1000);
  }

  function handleClearImage() {
    const profileImage = document.getElementById('profile-image');
    if (profileImage) {
    }
    setImage('');
  }

  const getImageUrl = async () => {
    if (!editor.current) return;

    const dataUrl = editor.current.getImageScaledToCanvas().toDataURL();
    const result = await fetch(dataUrl);
    const blob = await result.blob();

    const profileImage = document.getElementById('profile-image');
    if (profileImage) {
      profileImage.style.backgroundImage = `url(${window.URL.createObjectURL(blob)})`;
    }

    // return window.URL.createObjectURL(blob)
  };

  function getImagePlaceHolder() {
    if (!image && user && user.image && user.image.medium) {
      return { backgroundImage: `url(${user.image.medium.url})` };
    } else
      return {
        backgroundImage: `url(${noImage})`,
        backgroundSize: 'cover',
      };
  }

  // function switchAvatarPart(part: string) {
  //   const newAvatarConfig = { ...avatarConfig };
  //   console.log(newAvatarConfig);
  //   setAvatarConfig(newAvatarConfig);
  // }

  function switchAvatarPart(type: string, currentOpt?: any) {
    const opts: any = avatarDefaultOptions[type];
    const currentIdx = opts.findIndex((item: any) => item === currentOpt);
    const newIdx = (currentIdx + 1) % opts.length;
    const newAvatarConfig = { ...avatarConfig, [type]: opts[newIdx] };

    if (type === 'hairStyle') {
      newAvatarConfig['hatStyle'] = 'none';
    }

    setAvatarConfig(newAvatarConfig);
  }

  useEffect(() => {
    if (!user) return;

    setIsOpen(openModal === modalID);

    if (modalData && modalData.config) {
      setAvatarConfig(modalData.config);

      if (user.extra.avatar_type) {
        setAvatarType(user.extra.avatar_type);
      }
    }
  }, [user, openModal, modalData]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        contentLabel="Example Modal"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
        contentElement={() => (
          <div>
            <div className="w-[350px] bg-blue-dark text-white rounded-xl px-5 py-10 flex flex-col items-center space-y-5 flex-none mx-5">
              <div className="flex flex-row space-x-3">
                <Button
                  color="clear"
                  className={`${avatarType === 0 ? 'bg-yellow text-blue-dark border-0' : 'bg-transparent ring-2'} leading-none`}
                  onClick={() => setAvatarType(0)}
                  disabled={loading}
                >
                  AVATAR
                </Button>
                <Button
                  color="clear"
                  className={`${avatarType === 1 ? 'bg-yellow text-blue-dark border-0' : 'bg-transparent ring-2'} leading-none`}
                  onClick={() => setAvatarType(1)}
                  disabled={loading}
                >
                  IMAGEM
                </Button>
                <Button
                  color="clear"
                  className={`${avatarType === 2 ? 'bg-yellow text-blue-dark border-0' : 'bg-transparent ring-2'} leading-none`}
                  onClick={() => setAvatarType(2)}
                  disabled={loading}
                >
                  ALTERAR SENHA
                </Button>
              </div>

              {avatarType === 0 && (
                <div className="flex flex-col items-center">
                  <Avatar className="w-36 h-36" {...avatarConfig} />

                  <div className="flex-1 mt-3 grid grid-cols-3 flex-wrap gap-1">
                    <Button onClick={() => switchAvatarPart('faceColor', avatarConfig.faceColor)}>Pele</Button>
                    <Button onClick={() => switchAvatarPart('eyeStyle', avatarConfig.eyeStyle)}>Olhos</Button>
                    <Button onClick={() => switchAvatarPart('glassesStyle', avatarConfig.glassesStyle)}>Óculos</Button>
                    <Button onClick={() => switchAvatarPart('earSize', avatarConfig.earSize)}>Orelhas</Button>
                    <Button onClick={() => switchAvatarPart('mouthStyle', avatarConfig.mouthStyle)}>Boca</Button>
                    <Button onClick={() => switchAvatarPart('noseStyle', avatarConfig.noseStyle)}>Nariz</Button>
                  </div>

                  <div className="flex-1 mt-3 grid grid-cols-2 flex-wrap gap-1">
                    <Button onClick={() => switchAvatarPart('hairStyle', avatarConfig.hairStyle)}>Cabelo</Button>
                    <Button onClick={() => switchAvatarPart('hairColor', avatarConfig.hairColor)}>Cor do Cabelo</Button>
                  </div>

                  <div className="flex-1 w-full mt-3 grid grid-cols-2 flex-wrap gap-1">
                    <Button onClick={() => switchAvatarPart('hatStyle', avatarConfig.hatStyle)}>Acessório</Button>
                    <Button className="px-2" onClick={() => switchAvatarPart('hatColor', avatarConfig.hatColor)}>
                      Cor do Acc.
                    </Button>
                  </div>

                  <div className="flex-1 mt-3 grid grid-cols-3 flex-wrap gap-1">
                    <Button onClick={() => switchAvatarPart('shirtStyle', avatarConfig.shirtStyle)}>Camisa</Button>
                    <Button onClick={() => switchAvatarPart('shirtColor', avatarConfig.shirtColor)}>Cor</Button>
                    <Button onClick={() => switchAvatarPart('bgColor', avatarConfig.bgColor)}>Fundo</Button>
                  </div>
                </div>
              )}

              {avatarType === 1 && (
                <div>
                  <div
                    className="rounded-full relative z-2 mt-2 rounded-lg bg-black w-64 h-64"
                    style={getImagePlaceHolder()}
                    title={!image && user && user.image && user.image.medium ? 'Enviar nova imagem' : undefined}
                  >
                    <Dropzone
                      onDrop={(dropped: any) => setImage(dropped[0])}
                      multiple={false}
                      maxFiles={1}
                      noClick={!!image}
                      accept={{
                        'image/png': ['.png', '.jpeg', '.jpg', '.gif'],
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()} className={`${!image ? '!cursor-pointer' : ''}`}>
                          <AvatarEditor
                            ref={e => (editor.current = e)}
                            onImageChange={handleImageChange}
                            width={256}
                            height={256}
                            image={image}
                            borderRadius={256}
                            border={0}
                            className={`overflow-hidden rounded-full ${!image ? '!cursor-pointer' : ''}`}
                          />
                          <input {...getInputProps()} />
                        </div>
                      )}
                    </Dropzone>
                    {!!image ? (
                      <button
                        type="button"
                        onClick={handleClearImage}
                        className="absolute bottom-[5px] right-[5px] rounded-full flex flex-row items-center justify-center text-red-500 bg-white w-[40px] h-[40px]"
                        title="Excluir"
                      >
                        X
                      </button>
                    ) : null}
                    {!image && user && user.image && user.image.medium ? (
                      <button
                        type="button"
                        onClick={handleClearImage}
                        className="pointer-events-none absolute bottom-[5px] right-[5px] rounded-full flex flex-row items-center justify-center text-red-500 bg-white w-[40px] h-[40px]"
                        title="Enviar nova imagem"
                      >
                        <RiImageEditFill size={25} />
                      </button>
                    ) : null}
                  </div>
                </div>
              )}

              {avatarType === 2 && (
                <>
                  <div className="w-full">
                    <label className="text-white font-thin text-xs leading-none mb-2 block">Senha atual</label>
                    <div className="flex items-center justify-between w-full">
                      <input
                        type={typeInput1}
                        ref={ref => (senhaAtualRef.current = ref)}
                        onChange={e => setSenhaAtual(e.target.value)}
                        className="w-full h-8 bg-maastricht-blue text-white py-2 px-4 rounded-md leading-none text-sm font-light"
                        name="actualPass"
                        id="actualPass"
                      />
                      <button
                        onClick={() => setTypeInput1(lastVal => (lastVal === 'password' ? 'text' : 'password'))}
                        className="text-yellow ml-2"
                      >
                        {typeInput1 === 'password' ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                      </button>
                    </div>
                  </div>

                  <div className="w-full">
                    <label className="text-white font-thin text-xs leading-none mb-2 block">Nova senha</label>
                    <div className="flex items-center justify-between w-full">
                      <input
                        type={typeInput2}
                        ref={ref => (novaSenhaRef.current = ref)}
                        onChange={e => setNovaSenha(e.target.value)}
                        className="w-full h-8 bg-maastricht-blue text-white py-2 px-4 rounded-md leading-none text-sm font-light"
                        name="newPass"
                        id="newPass"
                      />
                      <button
                        onClick={() => setTypeInput2(lastVal => (lastVal === 'password' ? 'text' : 'password'))}
                        className="text-yellow ml-2"
                      >
                        {typeInput2 === 'password' ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                      </button>
                    </div>
                  </div>

                  <div className="w-full">
                    <label className="text-white font-thin text-xs leading-none mb-2 block">Confirmar nova senha</label>
                    <div className="flex items-center justify-between w-full">
                      <input
                        type={typeInput3}
                        ref={ref => (confirmarNovaSenhaRef.current = ref)}
                        onChange={e => setConfirmarNovaSenha(e.target.value)}
                        className="w-full h-8 bg-maastricht-blue text-white py-2 px-4 rounded-md leading-none text-sm font-light"
                        name="confirmNewPass"
                        id="confirmNewPass"
                      />
                      <button
                        onClick={() => setTypeInput3(lastVal => (lastVal === 'password' ? 'text' : 'password'))}
                        className="text-yellow ml-2"
                      >
                        {typeInput3 === 'password' ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                      </button>
                    </div>
                  </div>

                  {typeof passError === 'string' && passError.length && (
                    <p className="p-0 font-normal block text-center text-purple-light">{passError}</p>
                  )}
                </>
              )}

              {loading && (
                <div className="px-4 py-2 font-bold flex flex-row items-center space-x-4 border border-white border-opacity-50 rounded-full">
                  SALVANDO ALTERAÇÕES...
                </div>
              )}

              {!loading && (
                <div className="flex flex-row items-center space-x-4">
                  <Button
                    color="clear"
                    className="rounded-full bg-red-600 min-w-auto p-0 px-0 w-auto"
                    onClick={() => handleCloseModal()}
                  >
                    <FaTimesCircle size={36} />
                  </Button>{' '}
                  <Button color="clear" className="bg-green-600 w-auto p-0 px-0" onClick={() => handleUpload()}>
                    <div className="flex flex-row items-center">
                      <FaCheckCircle size={36} /> <span className="px-3">SALVAR</span>
                    </div>
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      />
    </>
  );
}
